import { Link } from "react-router-dom";
import { categoryEntries } from "@/mocks/filters";

export default function QuickEntries() {
  return (
    <section className="mt-10">
      <div className="mb-4 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">快捷分类入口</h2>
          <p className="mt-1 text-sm text-foreground-500">按频道与类型快速进入，海量影视一触即达</p>
        </div>
      </div>
      <div className="grid gap-4 md:grid-cols-3">
        {categoryEntries.map((entry) => (
          <Link
            key={entry.key}
            to={`/category/${entry.key}`}
            className="group relative flex h-36 cursor-pointer items-end overflow-hidden rounded-xl border border-background-200"
          >
            <img
              src={entry.cover}
              alt={`${entry.label} 分类入口`}
              title={`${entry.label} - 秋霞影院`}
              className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-transparent" />
            <div className="relative z-10 flex items-center gap-3 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500 text-white">
                <i className={`${entry.icon} text-2xl`} />
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-white">{entry.label}</h3>
                <p className="mt-0.5 text-xs text-background-200">{entry.description}</p>
              </div>
            </div>
          </Link>
        ))}

        <Link
          to="/search"
          className="group flex h-36 cursor-pointer flex-col justify-between rounded-xl border border-background-200 bg-primary-900 p-5 transition-colors hover:bg-primary-800"
        >
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500 text-white">
            <i className="ri-filter-3-line text-2xl" />
          </span>
          <div>
            <h3 className="font-heading text-base font-bold text-white">类型筛选</h3>
            <p className="mt-0.5 text-xs text-primary-100">按关键词组合检索，快速定位想看的影片</p>
          </div>
        </Link>
      </div>
    </section>
  );
}